import { LinkedApptCardProps } from "./LinkedApptCard.types";
import { Box, Typography, Card } from "@mui/material";
import { sxStyles } from "./LinkedApptCard.styles";
import ConfirmationCard from "../../pages/confirmation/ConfirmationCard/ConfirmationCard";
import { getDateFromISOString } from "lib/util/DateTimeUtil/getDateFromISOString/getDateFromISOString";
import IMAGES from "lib/assets/images";

const LinkedApptCard = ({
  appointment,
  newDateTime,
  showCalendarEditIcon = true,
  onSelect,
}: LinkedApptCardProps) => {
  const classes = sxStyles();
  return (
    <Box
      data-testid={"cardRegion"}
      sx={classes.cardRegion}
      onClick={() => onSelect()}
    >
      <Box sx={classes.linkedCardHeader}>
        <Typography sx={classes.institutionText}>
          {appointment.institutionName}
        </Typography>
        <Typography sx={classes.serviceText}>
          {appointment.serviceDisplayName}
        </Typography>
        <Typography sx={classes.clinicianText}>
          {appointment.clinician}
        </Typography>
      </Box>

      <Box sx={{ ...classes.layout, ...classes.cardSectionLayout }}>
        <Box sx={classes.cardLayout}>
          <Card sx={classes.card}>
            <Box sx={classes.cardtitle}>
              <Typography sx={classes.titleLeftText}>Current</Typography>
              <ConfirmationCard slotDateTime={appointment.datetime} />
            </Box>
            <Box
              component={"img"}
              src={IMAGES.general.ForwardIcon}
              sx={classes.arrow}
            />

            <Box sx={classes.cardtitle}>
              <Typography sx={classes.titleRightText}>New</Typography>
              {newDateTime ? (
                <Card sx={classes.setNewCard}>
                  {showCalendarEditIcon ? (
                    <Box
                      component="img"
                      src={IMAGES.appointment.CalendarEdit}
                      alt="Tap to set a new Date"
                      sx={classes.selectAgainButton}
                    />
                  ) : null}

                  <ConfirmationCard
                    slotDateTime={getDateFromISOString(newDateTime)}
                  />
                </Card>
              ) : (
                <Card sx={classes.setNewCard}>
                  <Box
                    component="img"
                    src={IMAGES.appointment.TapToSetNewDate}
                    alt="Tap to set a new Date"
                    sx={classes.setNewCardImg}
                  />
                </Card>
              )}
            </Box>
          </Card>
        </Box>
      </Box>
    </Box>
  );
};

export default LinkedApptCard;
